<template>
  <span class="Tooltip">
    <Icon :icon="'tooltip'" />
    <div class="Tooltip__Modal">
      <p class="p6" v-html="text"></p>
    </div>
  </span>
</template>

<script setup>
import Icon from './Icon.vue';

const props = defineProps({
  text: String,
});
</script>
